// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-6e4c9998] {\n  padding: 4px 15px;\n  height: 40px;\n  margin-right: 23px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: 1px solid #d9d9d9;\n}\n.btn.hit[data-v-6e4c9998] {\n  background: #1890ff;\n  color: #fff;\n  border: 1px solid #1890ff;\n}", ""]);
// Exports
module.exports = exports;
